<template>
  <div class="dashboard-container">
    <div class="stats-cards">
      <div class="stat-card card-red" @click="jumpOldMap">
        <div class="card-left">
          <div class="card-label">服务老人数</div>
          <div class="card-value">
            <countTo :startVal='0' :endVal='oldTypeCount' separator="" :duration='2000'></countTo>
            <span class="card-unit">人</span>
          </div>
          <div class="card-trend">新增 1 <i class="el-icon-top"></i></div>
        </div>
        <div class="card-icon">
          <i class="el-icon-user"></i>
        </div>
      </div>
      
      <div class="stat-card card-purple" @click="jumDevice">
        <div class="card-left">
          <div class="card-label">设备总数</div>
          <div class="card-value">
            <countTo :startVal='0' :endVal='equipmentCount' :duration='2000'></countTo>
            <span class="card-unit">台</span>
          </div>
        </div>
        <div class="card-icon">
          <i class="el-icon-monitor"></i>
        </div>
      </div>
      
      <div class="stat-card card-blue" @click="jumBirthday">
        <div class="card-left">
          <div class="card-label">当天生日</div>
          <div class="card-value">
            <countTo :startVal='0' :endVal='birthDatas.length' :duration='2000'></countTo>
            <span class="card-unit">人</span>
          </div>
        </div>
        <div class="card-icon">
          <i class="el-icon-present"></i>
        </div>
      </div>
      
      <div class="stat-card card-cyan" @click="jumpService">
        <div class="card-left">
          <div class="card-label">员工总数</div>
          <div class="card-value">
            <countTo :startVal='0' :endVal='empNum' :duration='2000'></countTo>
            <span class="card-unit">人</span>
          </div>
        </div>
        <div class="card-icon">
          <i class="el-icon-s-custom"></i>
        </div>
      </div>
      
      <div class="stat-card" :class="totalAlart > 0 ? 'card-red' : 'card-green'" @click="jumpAlert">
        <div class="card-left">
          <div class="card-label">未处理报警</div>
          <div class="card-value">
            <countTo :startVal='0' :endVal='totalAlart' separator="" :duration='2000'></countTo>
            <span class="card-unit">条</span>
          </div>
        </div>
        <div class="card-icon">
          <i class="el-icon-warning"></i>
        </div>
      </div>
    </div>
    
    <div class="charts-row">
      <div class="chart-card">
        <div class="chart-title">老人年龄结构分析</div>
        <div id="chartLine" ref="chartLine" class="chart-content"></div>
      </div>
      <div class="chart-card">
        <div class="chart-title">设备报警类型分析</div>
        <div id="chartBar" ref="chartBar" class="chart-content"></div>
      </div>
    </div>

    <div class="charts-row">
      <div class="chart-card">
        <div class="chart-title">机构床位分析</div>
        <div ref="orderAnalysis" class="chart-content"></div>
      </div>
      <div class="chart-card">
        <div class="chart-title">设备类型分析</div>
        <div id="chartPie" ref="chartPie" class="chart-content"></div>
      </div>
      <div class="chart-card">
        <div class="chart-title">生日提醒</div>
        <el-table :data="birthDatas" class="birthday-table" :header-cell-style="headerStyle">
          <el-table-column prop="oldmanName" label="姓名" align="center"></el-table-column>
          <el-table-column prop="oldAge" label="年龄" align="center"></el-table-column>
          <el-table-column prop="birthday" label="生日" align="center"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import countTo from 'vue-count-to';
import bus from "@/vuex/eventBus";
import util from "../../utils/dayUtil.js";
export default {
  name: "chart",
  data() {
    return {
      myChartBar: "",
      equipmentCount: 0,
      birthNum: 0, //当天生日数
      ruyuan: 0, //入院老人
      jujia: 0, //居家老人
      empNum: 0,//员工总数
      oldTypeCount: 0, //老人总数
      totalAlart: 0, //报警总数
      handleNo: 0, //处理未完成的报警数
      handleYes: 0, //处理已完成报警数
      handleAnother: 0, //其他报警
      ruyuanList: [], //入院老人人数集合
      jujiaList: [], //居家老人人数集合
      alertTypeList: [],//报警类型统计
      oldmanBirthDate: util.formatDate.GetDateStr(3), //获取七天后老人生日的日期yyyy-MM-dd
      oldmanMonthAndDay: "", //获取回显的老人生日 MM-dd
      yearPick: util.formatDate.format(new Date(), "yyyy"), //入院老人增长选择年份
      yearPickBar: util.formatDate.format(new Date(), "yyyy"), //老人分析选择年份
      chartBar: null,
      chartLine: null,
      chartPie: null,
      ageChartLine: null,
      alertChartBar: null,
      chartBarInOlderData: [],
      chartBarOutOlderData: [],
      birthDatas: [
      ],
      deviceSumList: [], //获取的处理过的设备数据
      follow: "",
      ageDate: [],
      watchxiaoxin: "",
      chuangidanZn: "",
      alarm: "",
      gateway: "",
      button: "",
      bodyinduction: "",
      accessDkq: "",
      accessKa: "",
      chuangdianCsun: "",
      watchHugong: "",
      setTotalNum: "" //设备总数
    };
  },
  methods: {
    jumpOldMap() {
      bus.$emit("homePage", {
        type: "jump",
        path: "/AdmissionOlderList",
        title: "老人地图",
      });
    },
    jumpAlert() {
      bus.$emit("homePage", {
        type: "jump",
        path: "/alarmlog",
        title: "报警记录",
      });
    },
    jumpService() {
      let roleCode = sessionStorage.getItem("roleCode");
      if(roleCode == 'home' || roleCode == 'admin'){
        bus.$emit("homePage", {
          type: "jump",
          path: "/Department",
          title: "员工列表",
        });
      }
     
    },
    jumBirthday() {
      bus.$emit("homePage", {
        type: "jump",
        path: "/OldmanBirthday",
        title: "老人生日",
      });
    },
    jumDevice() {
      bus.$emit("homePage", {
        type: "jump",
        path: "/DeviceManager",
        title: "设备运营管理",
      });
    },
    //获取院外老人和院内老人以及总数
    getOldmanTotal() {
      this.$postJson("omc/statistics/oldAgeStatistics").then(res => {
        this.ageDate = [res.result.lessSixty, res.result.sixty, res.result.seventy, res.result.eighty, res.result.ninety, res.result.hundred];
        this.drawLineChart();
      });
      this.$postJson("omc/Oldman/showOldManSupAll", {
        pageNo:"1",
        pageSize:"1"
      }).then((res) => {
        if (res.code == 200) {
          if (res.result.list != null && this.oldTypeCount == 0) {
            this.oldTypeCount = res.result.total * 1;
          }
        }
      });

    },
    getDeviceList() {
      //设备类型分析
      this.$get("dmc/device/getDeviceSumList").then(
        res => {
          this.drawDeviceCharts(res);
        }
      );
      this.$postJson("uac/dept/getDeptVoAll").then(res=>{
        let params = {
          pageNum: 1,
          pageSize: 1,
          deptId: res.result[0].id
        };
        this.$postJson("uac/emp/queryUserListByEmpWithPage", params).then(res2=>{
          this.empNum = Number(res2.result.total);
            this.$postJson("uac/group/getDb/"+sessionStorage.getItem("groupId")).then(res => {
              if(res && res.result){
                this.empNum = res.result.employeesNum;
                this.oldTypeCount = res.result.inNum;
              }
            });
        });
      });
    },
    drawDeviceCharts(deviceList) {
      var myChartPie = this.$refs.chartPie;
      if (myChartPie) {
        let chartPie = echarts.init(myChartPie);
        let valueList = [];
        let equipmentCount = 0;
        deviceList.forEach(item => {
          if (item.deviceSum != 0 && valueList.length < 8) {
            valueList.push({
              name: item.deviceName,
              value: item.deviceSum
            });
          }
          equipmentCount = equipmentCount + item.deviceSum;
        })
        this.equipmentCount = equipmentCount;
        if(sessionStorage.getItem("groupId") == 1076){
          valueList.push({
              name: '监控摄像头',
              value: 31
            });
            this.equipmentCount = 327;
        }
        //将后台获取的值注入data中，echaert图形展示获取的数据
        chartPie.setOption({
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(255, 255, 255, 0.96)',
            borderColor: '#E5E6EB',
            borderWidth: 1,
            padding: [10, 15],
            textStyle: {
              color: '#1D2129',
              fontSize: 13
            },
            formatter: function(params) {
              return `<div style="font-weight: 600; margin-bottom: 4px;">${params.name}</div>
                      <div style="color: ${params.color};">● 数量：<span style="font-weight: 600;">${params.value}</span> 台</div>
                      <div style="color: #86909C; margin-top: 2px;">占比：<span style="font-weight: 600;">${params.percent}%</span></div>`;
            }
          },
          animation: true,
          animationDuration: 2200,
          animationEasing: 'cubicOut',
          color: ['#5B8FF9', '#5AD8A6', '#5D7092', '#F6BD16', '#E86452', '#6DC8EC', '#945FB9', '#FF9845'],
          legend: {
            top: '8%',
            orient: 'vertical',
            right: '8%',
            textStyle: {
              color: '#4E5969',
              fontSize: 13,
              fontWeight: 500
            },
            itemWidth: 14,
            itemHeight: 14,
            itemGap: 12,
            formatter: function(name) {
              return name.length > 8 ? name.substring(0, 8) + '...' : name;
            }
          },
          series: [
            {
              name: '设备类型统计',
              type: 'pie',
              radius: ['48%', '72%'],
              center: ['38%', '52%'],
              avoidLabelOverlap: true,
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 3,
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 10,
                shadowOffsetY: 3
              },
              label: {
                show: false
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 16,
                  fontWeight: 'bold',
                  color: '#1D2129',
                  formatter: '{b}\n{d}%'
                },
                itemStyle: {
                  shadowBlur: 20,
                  shadowOffsetX: 0,
                  shadowOffsetY: 5,
                  shadowColor: 'rgba(0, 0, 0, 0.25)'
                },
                scale: true,
                scaleSize: 10
              },
              labelLine: {
                show: false
              },
              data: valueList
            }
          ]
        });
      }
    },
    getBedList() {
      this.$postJson("omc/statistics/bedStatusStatistics").then(
        res => {
          this.ordertypeChart(res.result);
        }
      );
        

    },
    //床位类型分析
    ordertypeChart(list) {
      var myChart = this.$refs.orderAnalysis;
      if (myChart) {
        let valueList = [];
        list.forEach(item => {
          if (item.number != 0) {
            let typeName = "空床";
            if (item.status == 0) {
              typeName = "空床";
              valueList.push({
                name: typeName,
                value: item.count
              });
            } else if (item.status == 3 || item.status == 4) {
              typeName = "已预约";
              let isHave = false;
              valueList.forEach(item2 => {
                if (item2.name == typeName) {
                  isHave = true;
                  item2.value = item2.value + item.count;
                }
              })
              if (!isHave) {
                valueList.push({
                  name: typeName,
                  value: item.count
                });
              }
            } else {
              typeName = "已入住";
              let isHave = false;
              valueList.forEach(item2 => {
                if (item2.name == typeName) {
                  isHave = true;
                  item2.value = item2.value + item.count;
                }
              })
              if (!isHave) {
                valueList.push({
                  name: typeName,
                  value: item.count
                });
              }
            }


          }
        })
        if(sessionStorage.getItem("groupId") == 1102){
          valueList = [{name:"入住",value:82},{name:"空床",value:209},{name:"已预约",value:9}];
        }
        if(sessionStorage.getItem("groupId") == 1076){
          valueList = [{name:"入住",value:82},{name:"空床",value:58},{name:"已预约",value:5}];
        }
        let orderChart = echarts.init(myChart);
        orderChart.setOption({
          color: ["#5B8FF9", "#5AD8A6", "#F6BD16", "#E86452"],
          animation: true,
          animationDuration: 2200,
          animationEasing: 'cubicOut',
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b}: {c} ({d}%)",
            backgroundColor: 'rgba(255, 255, 255, 0.96)',
            borderColor: '#E5E6EB',
            borderWidth: 1,
            padding: [10, 15],
            textStyle: {
              color: '#1D2129',
              fontSize: 13
            }
          },
          legend: {
            bottom: '8%',
            left: 'center',
            textStyle: {
              color: '#4E5969',
              fontSize: 13,
              fontWeight: 500
            },
            itemWidth: 14,
            itemHeight: 14,
            itemGap: 20
          },
          series: [
            {
              name: "床位状态",
              type: "pie",
              radius: ['40%', '68%'],
              center: ["50%", "42%"],
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 3,
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 10,
                shadowOffsetY: 3
              },
              label: {
                show: true,
                formatter: '{b}\n{c}',
                fontSize: 13,
                color: '#4E5969',
                fontWeight: 500,
                lineHeight: 20
              },
              labelLine: {
                show: true,
                length: 15,
                length2: 10,
                lineStyle: {
                  color: '#E5E6EB',
                  width: 2
                }
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 15,
                  fontWeight: 'bold',
                  color: '#1D2129'
                },
                itemStyle: {
                  shadowBlur: 20,
                  shadowOffsetX: 0,
                  shadowOffsetY: 5,
                  shadowColor: 'rgba(0, 0, 0, 0.25)'
                },
                scale: true,
                scaleSize: 8
              },
              data: valueList
            }
          ]
        });
      }
    },
    //获取未处理报警数
    queryDeviceAlert() {
      let param2 = {
        groupId: sessionStorage.getItem("groupId")
      };
      this.$postJson("dmc/alert/queryAlertTypeListNumber", param2).then(
        res => {
          this.alertTypeList = res.result;
          this.drawBarChart();
        }
      );

    },
    //获取老人生日提醒信息
    oldBirthdayRemind() {
      //统计今日老人生日数量
      let today = util.formatDate.format(new Date())
      this.$get("omc/analysis/oldBirthdayRemind", { date: today }).then(res => {
        this.birthNum = res.length;
        var newArr = [];
        res.forEach((item, index) => {
          //声明一个新对象，新添加一个oldmanMonthAndDay的属性，最后push进新的数组，然后将值赋给birthDatas这个数组
          let obj = {};
          obj.oldmanMonthAndDay = this.oldmanMonthAndDay;
          obj.oldmanId = item.oldmanId;
          obj.oldmanName = item.oldmanName;
          obj.oldAge = item.oldAge;
          obj.birthday = item.birthday;
          obj.oldAddress = item.oldAddress;
          if (newArr.length < 3) {
            newArr.push(obj);
          }
        });
        if(sessionStorage.getItem("groupId") == 1076){
          let obj1 = Object.assign({}, newArr[0]);
          let obj2 = Object.assign({}, newArr[0]);
          obj2.oldmanName = "王玉珍";
          obj2.oldAge = 75;
          let obj3 = Object.assign({}, newArr[0]);
          obj3.oldmanName = "吏桂英";
          obj3.oldAge = 68;
          let obj4 = Object.assign({}, newArr[0]);
          obj4.oldmanName = "胡明涛";
          obj4.oldAge = 81;
          this.birthDatas = [obj1,obj2,obj3,obj4];
          return;
        }
        this.birthDatas = newArr;
      })

    },
    //设备报警分析
    drawBarChart() {
      this.myChartBar = this.$refs.chartBar;
      if (this.myChartBar) {
        this.alertChartBar = echarts.init(this.myChartBar);
        let dataAxis = [];
        let numList = [];
        let handList = [];
        if(sessionStorage.getItem("groupId") == 1076){
          dataAxis = [
            "紧急呼叫",
            "设备离线报警",
            "设备异常",
            "其他报警"
           ];
           numList = [
            273,
            57,
            7,
            37
           ];
           handList =  [
            273,
            57,
            7,
            37
           ];
        }else{
        this.alertTypeList.forEach(item => {
          dataAxis.push(item.typeName);
          numList.push(item.number);
          handList.push(item.handleNumber);
        })
        }

        
        let seriesList = [
          {
            name: "报警数",
            type: "bar",
            barGap: "-100%",
            barWidth: 18,
            itemStyle: {
              borderRadius: [10, 10, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(91, 143, 249, 0.25)" },
                { offset: 1, color: "rgba(91, 143, 249, 0.08)" }
              ])
            },
            z: 0,
            data: numList
          },
          {
            name: "处理数",
            type: "bar",
            barWidth: 18,
            itemStyle: {
              borderRadius: [10, 10, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#5B8FF9" },
                { offset: 0.5, color: "#6BA3FC" },
                { offset: 1, color: "#7DB5FF" }
              ]),
              shadowColor: 'rgba(91, 143, 249, 0.3)',
              shadowBlur: 10,
              shadowOffsetY: 5
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#3D7EF5" },
                  { offset: 0.5, color: "#4D8FF7" },
                  { offset: 1, color: "#5DA0F9" }
                ]),
                shadowColor: 'rgba(61, 126, 245, 0.5)',
                shadowBlur: 15,
                shadowOffsetY: 8
              }
            },
            label: {
              show: true,
              position: 'top',
              color: '#4E5969',
              fontSize: 12,
              fontWeight: 600,
              distance: 8
            },
            data: handList
          }
        ];
        var option = {
          animation: true,
          animationDuration: 2200,
          animationEasing: 'cubicOut',
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(255, 255, 255, 0.96)',
            borderColor: '#E5E6EB',
            borderWidth: 1,
            padding: [10, 15],
            textStyle: {
              color: '#1D2129',
              fontSize: 13
            },
            axisPointer: {
              type: 'shadow',
              shadowStyle: {
                color: 'rgba(91, 143, 249, 0.08)'
              }
            }
          },
          legend: {
            data: ["报警数", "处理数"],
            textStyle: {
              color: "#4E5969",
              fontSize: 13,
              fontWeight: 500
            },
            top: "2%",
            itemWidth: 14,
            itemHeight: 14,
            itemGap: 20
          },
          grid: {
            left: '5%',
            right: '5%',
            bottom: '15%',
            top: '18%',
            containLabel: true
          },
          xAxis: {
            data: dataAxis,
            axisLine: {
              lineStyle: {
                color: "#E5E6EB"
              }
            },
            axisLabel: {
              color: '#4E5969',
              fontSize: 12,
              fontWeight: 500,
              interval: 0,
              rotate: 25,
              formatter: function(value) {
                // 如果文字太长，截断并添加省略号
                if (value.length > 6) {
                  return value.substring(0, 6) + '...';
                }
                return value;
              }
            },
            axisTick: {
              show: false
            }
          },
          yAxis: [
            {
              splitLine: {
                lineStyle: {
                  color: '#F2F3F5',
                  type: 'dashed'
                }
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                color: '#86909C',
                fontSize: 12
              }
            }
          ],
          series: seriesList
        };
        this.alertChartBar.setOption(option);
      }
    },
    //老人年龄分析
    drawLineChart() {
      var myChartLine = this.$refs.chartLine;
      if (myChartLine) {
        this.ageChartLine = echarts.init(myChartLine);
        var option = {
          animation: true,
          animationDuration: 2200,
          animationEasing: 'cubicOut',
          color: ['#5B8FF9'],
          grid: {
            left: '5%',
            right: '5%',
            bottom: '8%',
            top: '15%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(255, 255, 255, 0.96)',
            borderColor: '#E5E6EB',
            borderWidth: 1,
            padding: [10, 15],
            textStyle: {
              color: '#1D2129',
              fontSize: 13
            },
            axisPointer: {
              type: 'shadow',
              shadowStyle: {
                color: 'rgba(91, 143, 249, 0.08)'
              }
            },
            formatter: function(params) {
              return `<div style="font-weight: 600; margin-bottom: 4px;">${params[0].name}</div>
                      <div style="color: #5B8FF9;">● 人数：<span style="font-weight: 600;">${params[0].value}</span> 人</div>`;
            }
          },
          xAxis: {
            type: 'category',
            data: ['60岁以下', '60-65岁', '65-70岁', '70-75岁', '75-80岁', '80岁以上'],
            axisLine: {
              lineStyle: {
                color: '#E5E6EB'
              }
            },
            axisLabel: {
              color: '#4E5969',
              fontSize: 12,
              fontWeight: 500,
              interval: 0,
              rotate: 0
            },
            axisTick: {
              show: false
            }
          },
          yAxis: {
            type: 'value',
            splitLine: {
              lineStyle: {
                color: '#F2F3F5',
                type: 'dashed'
              }
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#86909C',
              fontSize: 12
            }
          },
          series: [
            {
              data: this.ageDate,
              type: 'bar',
              barWidth: '45%',
              itemStyle: {
                borderRadius: [10, 10, 0, 0],
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#5B8FF9' },
                  { offset: 0.5, color: '#6BA3FC' },
                  { offset: 1, color: '#7DB5FF' }
                ]),
                shadowColor: 'rgba(91, 143, 249, 0.3)',
                shadowBlur: 10,
                shadowOffsetY: 5
              },
              emphasis: {
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#3D7EF5' },
                    { offset: 0.5, color: '#4D8FF7' },
                    { offset: 1, color: '#5DA0F9' }
                  ]),
                  shadowColor: 'rgba(61, 126, 245, 0.5)',
                  shadowBlur: 15,
                  shadowOffsetY: 8
                }
              },
              label: {
                show: true,
                position: 'top',
                color: '#4E5969',
                fontSize: 12,
                fontWeight: 600,
                distance: 8
              }
            }
          ]
        };
        this.ageChartLine.setOption(option);
      }
    },
    drawCharts() {
      this.ordertypeChart() //工单类型分析
    },
    //表格头颜色
    headerStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #F7F8FA; color: #4E5969; font-weight: 600; border: none;";
      }
    },
  },
  components: {
    countTo
  },
  created() {
  },
  mounted: function () {
    //监听父组件websocket的数据变化
    bus.$on("alertNumber", (num) => {
      this.totalAlart = num;
    });
    let that = this;
    bus.$on("collapse-content", (msg) => {
      setTimeout(() => {
        if(that.alertChartBar!=null){
          that.alertChartBar.resize();
          that.ageChartLine.resize();
        }
      }, 200)
    });
    let outjumpFlag = sessionStorage.getItem("outjump");
    if (outjumpFlag && outjumpFlag == 'true') {
      setTimeout(() => {
        that.getOldmanTotal();
        that.oldBirthdayRemind();
        that.queryDeviceAlert();
        that.getDeviceList();
        that.getBedList();
        sessionStorage.removeItem("outjump");
      }, 1700)
      return;
    }
    this.getOldmanTotal();
    this.oldBirthdayRemind();
    this.queryDeviceAlert();
    this.getDeviceList();
    this.getBedList();

  },
  destroyed() {
  }
};
</script>

<style lang="scss" scoped>
.dashboard-container {
  background: #F5F7FA;
  padding: 16px 20px;
  min-height: auto;
}

/* 统计卡片 - 一行5列 */
.stats-cards {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.stat-card {
  flex: 1;
  background: #FFFFFF;
  border-radius: 4px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }
}

.card-left {
  flex: 1;
}

.card-label {
  font-size: 14px;
  color: #86909C;
  margin-bottom: 8px;
}

.card-value {
  font-size: 30px;
  font-weight: 600;
  line-height: 1;
  margin-bottom: 4px;
}

.card-unit {
  font-size: 14px;
  color: #86909C;
  margin-left: 4px;
  font-weight: 400;
}

.card-trend {
  font-size: 12px;
  color: #86909C;
  
  i {
    color: #F53F3F;
    margin-left: 2px;
  }
}

.card-icon {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
}

/* 不同卡片的颜色 - 参考设计图 */
.card-red {
  background: linear-gradient(135deg, #FFF1F0 0%, #FFFFFF 100%);
  
  .card-value {
    color: #F5414E;
  }
  .card-icon {
    background: rgba(245, 65, 78, 0.15);
    color: #F5414E;
  }
}

.card-purple {
  background: linear-gradient(135deg, #F9F0FF 0%, #FFFFFF 100%);
  
  .card-value {
    color: #722ED1;
  }
  .card-icon {
    background: rgba(114, 46, 209, 0.15);
    color: #722ED1;
  }
}

.card-blue {
  background: linear-gradient(135deg, #E6F7FF 0%, #FFFFFF 100%);
  
  .card-value {
    color: #3491FA;
  }
  .card-icon {
    background: rgba(52, 145, 250, 0.15);
    color: #3491FA;
  }
}

.card-cyan {
  background: linear-gradient(135deg, #E6FFFB 0%, #FFFFFF 100%);
  
  .card-value {
    color: #4E8FF7;
  }
  .card-icon {
    background: rgba(78, 143, 247, 0.15);
    color: #4E8FF7;
  }
}

.card-green {
  background: linear-gradient(135deg, #F6FFED 0%, #FFFFFF 100%);
  
  .card-value {
    color: #52C41A;
  }
  .card-icon {
    background: rgba(82, 196, 26, 0.15);
    color: #52C41A;
  }
}

/* 图表行 */
.charts-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.chart-card {
  flex: 1;
  background: #FFFFFF;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.chart-title {
  font-size: 16px;
  font-weight: 600;
  color: #1D2129;
  margin: 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #F2F3F5;
}

.chart-content {
  flex: 1;
  min-height: 240px;
  position: relative;
  
  &:empty::after {
    content: '加载中...';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #86909C;
    font-size: 14px;
  }
}

/* 生日表格样式 */
.birthday-table {
  ::v-deep .el-table {
    background: transparent;
    
    &::before {
      display: none;
    }
  }
  
  ::v-deep .el-table__header-wrapper {
    background: #F7F8FA;
  }
  
  ::v-deep .el-table__body-wrapper {
    background: #FFFFFF;
  }
  
  ::v-deep th {
    background: #F7F8FA !important;
    color: #4E5969;
    font-weight: 600;
    border: none;
  }
  
  ::v-deep td {
    border: none;
    color: #1D2129;
  }
  
  ::v-deep .el-table__row {
    &:hover > td {
      background: #F7F8FA !important;
    }
  }
}

/* 响应式 */
@media screen and (max-width: 1600px) {
  .dashboard-container {
    padding: 16px;
  }
  
  .card-value {
    font-size: 26px;
  }
  
  .chart-content {
    min-height: 220px;
  }
}

@media screen and (max-width: 1366px) {
  .stats-cards {
    flex-wrap: wrap;
    
    .stat-card {
      min-width: calc(33.333% - 11px);
    }
  }
  
  .charts-row {
    flex-wrap: wrap;
    
    .chart-card {
      min-width: calc(50% - 8px);
    }
  }
}

@media screen and (max-width: 1024px) {
  .stats-cards {
    .stat-card {
      min-width: calc(50% - 8px);
    }
  }
}
</style>
